






import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  props: {
    autofocus: {
      type: Boolean,
      default: true
    }
  }
})
export default class TableSubRow extends Vue {
  observer: any = null

  mounted () {
    // this.$nextTick(() => {
    //   this.$el.scrollIntoView({ inline: 'nearest' })
    // })

    if (!this.$props.autofocus) {
      return
    }

    this.$nextTick(() => {
      setTimeout(() => {
        /* eslint-disable */
        // @ts-ignore
        this.observer = new window.IntersectionObserver(([entry]: any) => {
          /* eslint-enable */
          if (entry.isIntersecting) {
            this.observer.unobserve(entry.target)
            return
          }

          this.$el.scrollIntoView({ block: 'end', inline: 'nearest' })
          this.observer.unobserve(entry.target)
        }, {
          root: null,
          threshold: 0.85
        })

        this.observer.observe(this.$el)
      }, 350)
    })
  }

  beforeDestroy () {
    if (!this.$props.autofocus) {
      return
    }

    if (this.observer) {
      this.observer.disconnect()
    }
    this.observer = null
  }
}
